import React from 'react';

import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { media } from '../../services/media';
import { classNames } from '../../services/classNames';
import { themeStyles } from '../../services/themeStyles';

interface Container {
    className?: string;
    size?: string;
    sizeGroup?: 'size-1' | 'size-2' | 'size-3';
}

export const Container: React.FC<Container> = ({
    className,
    sizeGroup,
    children,
    ...props
}) => (
    <StyledContainer
        className={classNames(sizeGroup ? sizeGroup : '', className || '')}
        {...props}
    >
        {children}
    </StyledContainer>
);

const Formue = themeStyles(
    'formue',
    css`
        &.size-1 {
            ${media.min('lg')} {
                max-width: 1440px;
            }
        }

        &.size-3 {
            ${media.min('lg')} {
                max-width: 1120px;
            }
        }
    `,
);

const StyledContainer = styled.div<Container>`
    width: 100%;
    padding: 0 15px;

    margin: 0 auto;

    ${(props) => props.size && `max-width: ${props.size};`}

    &.size-1 {
        ${media.min('lg')} {
            max-width: 1700px;
        }
    }

    &.size-2 {
        ${media.min('md')} {
            max-width: 700px;
        }

        ${media.min('lg')} {
            max-width: 1670px;
            padding: 0 110px;
        }
    }

    &.size-3 {
        max-width: 400px;

        ${media.min('md')} {
            max-width: 700px;
        }

        ${media.min('lg')} {
            max-width: 1170px;
        }
    }

    ${Formue}
`;
